module.exports = __webpack_public_path__ + "static/media/logo-white.0f4542cc.png";